import { render } from "./ProductSelectorLine.vue?vue&type=template&id=42ed134e&scoped=true&ts=true"
import script from "./ProductSelectorLine.vue?vue&type=script&lang=ts"
export * from "./ProductSelectorLine.vue?vue&type=script&lang=ts"

import "./ProductSelectorLine.vue?vue&type=style&index=0&id=42ed134e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ed134e"]])

export default __exports__